import isNil from 'lodash/isNil';

import type { NonMutable, Nullable } from './object';

const compareNullable = <T>(
  a: Nullable<T>,
  b: Nullable<T>,
  compareFn: (x: T, y: T) => number,
): number => {
  if (isNil(a) && isNil(b)) {
    return 0;
  }
  if (isNil(a)) {
    return 1;
  }
  if (isNil(b)) {
    return -1;
  }
  return compareFn(a, b);
};

const compareNumbers = (a: number, b: number): number => a - b;

export const compareDates = (a: Date, b: Date): number => a.getTime() - b.getTime();
export const compareStrings = (a: string, b: string): number => (
  a.toLowerCase().localeCompare(b.toLowerCase())
);

const naturalCollator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

export const compareNatural = (a: string, b: string): number => naturalCollator.compare(a, b);

export const compareNullableDates = (a: Nullable<Date>, b: Nullable<Date>): number => (
  compareNullable(a, b, compareDates)
);
export const compareNullableNumbers = (a: Nullable<number>, b: Nullable<number>): number => (
  compareNullable(a, b, compareNumbers)
);
export const compareNullableStrings = (a: Nullable<string>, b: Nullable<string>): number => (
  compareNullable(a, b, compareStrings)
);

export const compareByOrder = <T>(order: NonMutable<T[]>) => {
  const indices = new Map(order.map((item, index) => [item, index] as const));

  return (a: T, b: T): number => compareNullable(indices.get(a), indices.get(b), compareNumbers);
};
